import OpenGraphTags from './partials/OpenGraph';
import MetaTags from './partials/Meta';

/**
 * @param {HeadWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
const HeadWrapper = ({ openGraph, meta, url, imgProperties, language }) => {
  return (
    <>
      <MetaTags
        {...meta}
        noIndex={meta.robots?.noIndex ?? undefined}
        language={language}
      />
      <OpenGraphTags
        {...openGraph}
        metaDescription={meta.description}
        metaTitle={meta.title}
        imgProperties={imgProperties}
        url={url}
      />
    </>
  );
};

export default HeadWrapper;
